export const QuivrColorLogo: React.FC = () => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 997 602.3"
  >
    <polygon
      style={{ fill: "#003153" }}
      points="521.5 210.1 503.1 217.4 503.1 360.1 539.3 360.1 539.3 217.2 521.5 210.1"
    />
    <g>
      <g>
        <path
          style={{ fill: "#003153" }}
          d="M177,353.2c-11-6.1-19.7-14.8-26-26-6.3-11.2-9.4-24.1-9.4-38.7s3.2-27.5,9.7-38.7c6.5-11.2,15.3-19.8,26.5-26,11.2-6.1,23.7-9.2,37.4-9.2s26.3,3.1,37.4,9.2c11.2,6.1,20,14.8,26.5,26,6.5,11.2,9.7,24.1,9.7,38.7s-3.3,27.5-9.9,38.7c-6.6,11.2-15.6,19.8-26.9,26-11.3,6.1-23.9,9.2-37.8,9.2s-26.2-3.1-37.2-9.2ZM232.7,326.1c5.8-3.2,10.4-8,13.8-14.3,3.4-6.4,5.2-14.1,5.2-23.2,0-13.6-3.6-24.1-10.7-31.4-7.1-7.3-15.9-11-26.2-11s-19,3.7-26,11c-7,7.3-10.5,17.8-10.5,31.4s3.4,24.1,10.2,31.4c6.8,7.3,15.4,11,25.7,11s12.7-1.6,18.5-4.8Z"
        />
        <path
          style={{ fill: "#003153" }}
          d="M643.1,326.7l36.2-109.7h38.5l-52.9,143.1h-43.9l-52.7-143.1h38.7l36.2,109.7Z"
        />
      </g>
      <polygon
        style={{ fill: "#003153" }}
        points="289.2 377.8 249.7 377.8 249.7 338.3 289.2 377.8"
      />
      <path
        style={{ fill: "#003153" }}
        d="M821.5,215.1l-15.2.7-23.5,23.5v-22.4h-36.1v143.1h36.2v-71.3c0-13.3,2.9-22.5,8.7-27.9,5.8-5.3,14.3-8,25.7-8h9.6v-38c-1.8,0-3.5,0-5.2.2Z"
      />
      <path
        style={{ fill: "#003153" }}
        d="M422.6,217v78.8c0,11.4-2.8,20.1-8.5,26.2-5.7,6.1-13.5,9.2-23.5,9.2s-17.6-3.1-23.2-9.2c-5.7-6.1-8.5-14.8-8.5-26.2v-78.8h-36.2v83.9c0,12.7,2.5,23.7,7.4,32.9,4.9,9.2,11.7,16.2,20.3,20.9,8.6,4.7,18.5,7.1,29.7,7.1s22.8-1,22.8-1l20-20v19.2h36.2v-143.1h-36.4Z"
      />
      <polygon
        style={{ fill: "#f09000" }}
        points="521.6 194.4 487.9 207.9 520.8 136.9 555 207.9 521.6 194.4"
      />
    </g>
    <g>
      <polygon
        style={{ fill: "#f09000" }}
        points="850.8 390.6 849.4 409.9 832.8 400.8 850.8 390.6"
      />
      <path
        style={{ fill: "#f09000" }}
        d="M781.5,453.7c0,0-8.8,4.3-8.8,4.3h0c0,0,24.5-35.3,24.5-35.3,0,0,0,0,0,0l19.8,11.9s0,0,0,0l22.4-32.5h0s6,2.6,6,2.6h0s-26.4,38.4-26.4,38.4c0,0,0,0,0,0l-20.3-12.4s0,0,0,0c0,0-4.4,5.7-6.4,8.4-3.7,5-11,14.7-11,14.7"
      />
      <path
        style={{ fill: "#003153" }}
        d="M722.5,441.8c-4.6,0-8-1.5-10.4-4.6-2.4-3.1-3.6-7.5-3.6-13.4v-27.6h8.6v25.7c0,3.7.7,6.4,2,8.2,1.3,1.8,3.1,2.6,5.7,2.6s4.8-.9,6.2-2.6c1.3-1.8,2-4.4,2-8l-.3-25.9h8.9l.2,45.7h-9l.3-5.3c-1.2,1.7-2.7,3-4.4,3.8-1.7.8-3.7,1.3-5.9,1.3Z"
      />
      <path
        style={{ fill: "#003153" }}
        d="M749.3,458v-61.7h8.5v4.5c2.5-2.9,5.6-4.4,9.3-4.4s6.3.9,8.7,2.8c2.4,1.8,4.3,4.5,5.6,7.8,1.3,3.4,2,7.4,2,12.1s-.7,8.6-2.1,12c-1.4,3.4-3.3,6-5.7,7.9-2.5,1.9-5.3,2.8-8.6,2.8s-3.7-.4-5.2-1.1c-1.5-.7-2.8-1.9-4-3.4v16.4l-8.7,4.4ZM765.8,432.7c2.9,0,5.1-1.2,6.6-3.6,1.5-2.4,2.3-5.7,2.3-10.1s-.8-7.7-2.4-10.1c-1.6-2.4-3.8-3.6-6.5-3.6s-3.2.4-4.5,1.1c-1.3.8-2.4,1.9-3.3,3.3v18.4c.9,1.4,2,2.6,3.4,3.3,1.4.8,2.8,1.2,4.4,1.2Z"
      />
      <g>
        <path
          style={{ fill: "#003153" }}
          d="M485,441.9c-4.6,0-8.3-1.2-10.8-3.7-2.6-2.5-3.9-6-3.9-10.4s.6-5.3,1.9-7.3c1.3-2.1,3.1-3.6,5.5-4.8,2.4-1.1,5.2-1.7,8.4-1.7s4.5.3,6.8,1c2.3.7,4.5,1.7,6.8,3.1v-6.5c0-4.3-.9-7.4-2.8-9.4-1.8-2-4.7-3.1-8.5-3.1s-4.3.4-6.8,1.1c-2.4.7-4.8,1.8-7.2,3.1l-1-2.6c2.6-1.4,5.2-2.5,7.8-3.2,2.6-.7,5-1.1,7.4-1.1,4.6,0,8.1,1.2,10.6,3.6,2.5,2.4,3.7,5.9,3.7,10.4v31.5h-3.4l.2-7.8c-1.8,2.5-4.1,4.4-6.7,5.8-2.6,1.4-5.3,2.1-8,2.1ZM485,439.1c2.7,0,5.2-.7,7.7-2.2,2.4-1.4,4.8-3.6,7-6.4v-9.4c-2.2-1.4-4.4-2.4-6.8-3.1-2.3-.7-4.6-1.1-6.8-1.1-3.6,0-6.6,1-8.9,3-2.3,2-3.4,4.7-3.4,8s1,6.2,3.1,8.2c2,2.1,4.8,3.1,8.1,3.1Z"
        />
        <path
          style={{ fill: "#003153" }}
          d="M514.8,441.9l.2-45.7h3.1v10.5c1.4-3.2,3.3-5.8,5.6-7.6,2.4-1.8,5-2.7,8-2.7s4.8.6,6.1,1.8l-.5,3.1c-.8-.5-1.7-.8-2.7-1.1-1.1-.2-2.2-.4-3.3-.4-2.6,0-4.8.7-6.8,2.2-2,1.4-3.5,3.5-4.6,6-1.1,2.6-1.7,5.5-1.7,8.8v25.1c0,0-3.4,0-3.4,0Z"
        />
        <path
          style={{ fill: "#003153" }}
          d="M543.2,441.9l-.2-45.7h3.4v10.5c1.3-3.2,3.2-5.8,5.5-7.6,2.4-1.8,5-2.7,8-2.7s4.8.6,6.1,1.8l-.5,3.1c-.8-.5-1.7-.8-2.7-1.1-1.1-.2-2.2-.4-3.3-.4-2.6,0-4.8.7-6.8,2.2-2,1.4-3.5,3.5-4.6,6-1.1,2.6-1.7,5.5-1.7,8.8v25.1h-3.3Z"
        />
        <path
          style={{ fill: "#003153" }}
          d="M584.7,441.9c-5.6,0-10.1-2-13.3-6.1-3.3-4.1-4.9-9.6-4.9-16.6s.7-8.7,2.2-12.1c1.5-3.4,3.6-6.1,6.3-7.9,2.7-1.9,6-2.8,9.7-2.8s7,.9,9.7,2.7c2.7,1.8,4.8,4.4,6.3,7.8,1.5,3.4,2.2,7.4,2.2,12.1s-.7,8.7-2.2,12.1c-1.5,3.4-3.6,6.1-6.3,7.9-2.7,1.9-6,2.8-9.7,2.8ZM584.7,438.9c4.7,0,8.3-1.7,10.9-5.2,2.6-3.5,3.9-8.3,3.9-14.6s-1.3-11.1-3.8-14.6c-2.6-3.4-6.2-5.1-10.9-5.1s-8.4,1.7-11,5.1c-2.5,3.4-3.8,8.3-3.8,14.7s1.3,11.1,3.8,14.6c2.6,3.4,6.2,5.1,10.9,5.1Z"
        />
        <path
          style={{ fill: "#003153" }}
          d="M618.5,441.9l-11.6-45.7h3.1l9.3,34.7c.2.7.4,1.4.5,2.1s.4,1.5.5,2.2c.2-.8.5-1.5.7-2.2.2-.7.4-1.4.7-2.1l11-34.7h2.2l11.2,34.7c.2.7.5,1.4.7,2.1s.4,1.5.7,2.2c.2-.8.4-1.5.5-2.2.2-.7.4-1.4.5-2.1l8.8-34.7h3.4l-11.7,45.7h-2.5l-10.7-33c-.3-.9-.6-1.9-.9-2.9-.3-1-.6-2-1-3-.3,1-.6,2-.9,3-.3,1-.6,1.9-1,2.9l-10.8,33h-2.7Z"
        />
        <path
          style={{ fill: "#003153" }}
          d="M680.1,441.9c-2.7,0-5.3-.6-7.8-1.7-2.5-1.1-4.7-2.7-6.7-4.9l2.5-2c1.8,1.8,3.7,3.2,5.8,4.2,2.1,1,4.1,1.5,6.1,1.5,3.4,0,6-.7,7.8-2.2,1.8-1.4,2.7-3.5,2.7-6.2s-.4-3-1.3-4.4c-.9-1.3-2.2-2.6-4.1-3.7-1.9-1.1-4.3-2.2-7.2-3.2-4.5-1.6-7.7-3.3-9.6-5.2-2-1.9-2.9-4.3-2.9-7.1s1.2-5.8,3.7-7.8c2.5-2,5.8-3,9.8-3s4.9.5,7.3,1.4c2.3.9,4.4,2.3,6,4l-2.4,2c-3.3-2.9-7-4.4-10.9-4.4s-5.6.7-7.4,2.1c-1.8,1.4-2.7,3.3-2.7,5.7s.8,3.9,2.4,5.3c1.6,1.4,4.6,2.9,8.9,4.4,3.5,1.2,6.3,2.5,8.3,3.8,2,1.3,3.5,2.8,4.3,4.4.8,1.6,1.3,3.5,1.3,5.6,0,3.5-1.2,6.2-3.7,8.2-2.5,2-5.8,3-10.1,3Z"
        />
      </g>
      <line
        style={{ fill: "#003153" }}
        x1="749.3"
        y1="458"
        x2="758"
        y2="453.7"
      />
      <line
        style={{ fill: "#003153" }}
        x1="758"
        y1="453.7"
        x2="749.3"
        y2="458"
      />
    </g>
    <g>
      <path
        style={{ fill: "#003153" }}
        d="M428.9,401.8c.9-.5,1.9-.7,3-.7s2.5.3,3.5,1c1.1.6,1.9,1.6,2.5,2.7.6,1.2.9,2.5.9,4.1s-.3,2.9-.9,4.1c-.6,1.2-1.4,2.1-2.5,2.8-1.1.7-2.2,1-3.5,1s-2.1-.2-3-.7-1.5-1-2-1.7v2.2h-3.8v-20.3h3.8v7.3c.5-.7,1.2-1.3,2-1.8ZM434.3,406.6c-.4-.7-.9-1.2-1.5-1.5-.6-.3-1.3-.5-2-.5s-1.3.2-2,.5c-.6.4-1.1.9-1.5,1.6-.4.7-.6,1.5-.6,2.4s.2,1.7.6,2.4c.4.7.9,1.2,1.5,1.6.6.4,1.3.5,2,.5s1.4-.2,2-.5c.6-.4,1.1-.9,1.5-1.6.4-.7.6-1.5.6-2.4s-.2-1.7-.6-2.4Z"
      />
      <path
        style={{ fill: "#003153" }}
        d="M457,401.4l-9.4,22.4h-4.1l3.3-7.6-6.1-14.8h4.3l3.9,10.6,4-10.6h4.1Z"
      />
    </g>
  </svg>
);
